import { render, staticRenderFns } from "./SaleOffersAnnouncement.vue?vue&type=template&id=416bc711&"
import script from "./SaleOffersAnnouncement.vue?vue&type=script&lang=js&"
export * from "./SaleOffersAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports